import * as Sentry from '@sentry/nuxt'

export default async function (email?: string | null): Promise<void> {
  if (Sentry) {
    if (email) {
      Sentry.setUser({ email: email })
    }
  }
  else {
    console.warn('Sentry is not initialized or available.')
  }
}
